const toEnumClass = (classPrefix, name, namedDefault) => {
  if (name === void 0 || name === "default") {
    if (namedDefault === void 0) {
      return;
    }
    name = namedDefault;
  }
  return `${classPrefix}${name}`;
};
export {
  toEnumClass
};
//# sourceMappingURL=toEnumClass.js.map
